import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import Checkout from './Checkout';

const StripedCheckout = ({ stripe, ...rest }) => (
	<Elements stripe={stripe}>
		<Checkout {...rest} />
	</Elements>
);

export default StripedCheckout;
